import React, {Component} from "react"
import PropTypes from "prop-types"
import styles from "../user/UserPage/UserPage.scss";
import SearchHistory from "../user/UserPage/components/SearchHistory";

class MemberDetails extends Component {
    render() {
        const {member} = this.props
        const {_id, IPs} = member
        const IPsValidated = Array.isArray(IPs) ? IPs : []

        return (
            <div>
                <table>
                    <tbody>
                    <tr>
                        <td><label>IPs</label></td>
                        <td>
                            {IPsValidated.join(', ')}
                        </td>
                    </tr>
                    <tr className={styles.field}>
                        <td>
                            <label>Search History</label>
                        </td>
                        <td>
                            <SearchHistory userId={_id}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

MemberDetails.propTypes = {
    member: PropTypes.object.isRequired
}

export default MemberDetails


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/team/MemberDetails.js